/** Entry point of the barcelona package (Barcelona). Imported once from main.ts. */
import '../render/propsBarcelona';
import './barcelona';
import { registerNpcs } from '../world/npcs';
import { NPCS_BARCELONA } from '../world/npcsBarcelona';

registerNpcs(NPCS_BARCELONA);
